import { api } from "@/lib/api";

export interface MarketCandle {
  t: number;
  close: number;
}

export async function getMarketCandles(
  symbol: string,
  opts: { from: number; to: number; interval?: "1m" | "5m" | "15m" | "30m" | "60m" | "1d" },
): Promise<MarketCandle[]> {
  const params = new URLSearchParams({
    symbol,
    from: String(Math.floor(opts.from)),
    to: String(Math.ceil(opts.to)),
    interval: opts.interval ?? "5m",
  });
  const res = await api.get<{ candles: MarketCandle[] }>(
    `/api/market/candles?${params.toString()}`,
  );
  return res.candles;
}
